import { render, staticRenderFns } from "./RiderForm.vue?vue&type=template&id=04e3aa84"
import script from "./RiderForm.vue?vue&type=script&lang=js"
export * from "./RiderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports